export default __webpack_public_path__ + "8f9e54336329eea410c242d875f0d102.jpg";